import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { CampaignSummaryField } from '@fmnts/api/next';
import { isNumber } from '@fmnts/core';
import {
  AbstractDeclarativeFieldComponent,
  TemplateBuilder,
  ensureTemplate,
  interpolateTemplate,
} from '@fmnts/declarative-forms';
import { Observable, map, of } from 'rxjs';
import { SharedDeclarativeCampaignFormsModule } from '../../shared-declarative-next-forms.module';

@Component({
  selector: 'next-amount-summary-field',
  templateUrl: './amount-summary-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedDeclarativeCampaignFormsModule],
})
export class AmountSummaryFieldComponent
  extends AbstractDeclarativeFieldComponent<CampaignSummaryField>
  implements OnInit
{
  protected readonly templateBuilder = inject(TemplateBuilder);

  protected content$: Observable<number>;
  protected currency$: Observable<string>;

  ngOnInit() {
    const { defaultValue } = this.field.widgetOptions;
    const currency = this.field.attrs?.['currency'];

    if (isNumber(defaultValue)) {
      this.content$ = of(defaultValue);
    } else {
      this.content$ = this.getAmount$(defaultValue);
    }

    this.currency$ = this.getCurrency$(currency);
  }

  /**
   * @param fieldReference
   *
   * @returns
   * An observable that emits with the date
   */
  private getAmount$(fieldReference: string): Observable<number> {
    return of(fieldReference).pipe(
      // Ensure that for any emitted value that references a field
      // that it is transformed into templating form of `{{some-field-key}}`
      map((s) => ensureTemplate(s, this.declaration)),
      interpolateTemplate((part) => this.templateBuilder.interpolate(part)),
      map((r) => Number(r)),
    );
  }

  /**
   * @param fieldReference
   *
   * @returns
   * An observable that emits with the date
   */
  private getCurrency$(fieldReference: string): Observable<string> {
    return of(fieldReference).pipe(
      // Ensure that for any emitted value that references a field
      // that it is transformed into templating form of `{{some-field-key}}`
      map((s) => ensureTemplate(s, this.declaration)),
      interpolateTemplate((part) => this.templateBuilder.interpolate(part)),
    );
  }
}
